import { create } from "zustand";

export const useInspectorStore = create((set) => ({
  actas: [],
  acta: null,
  refetch: false,

  //   asignarInspector: false,
  //   inspectores: null,
  //   inspectorAsignado: null,
  //   solicitudesAsignar: [],

  setActas: (actas) => {
    set({ actas: actas });
  },
  setActa: (acta) => {
    set({ acta: acta });
  },

  setRefetch: (value) => {
    set({ refetch: value });
  },
  //   setInspectores: (inspectores) => {
  //     set({ inspectores: inspectores });
  //   },
  //   setAsignarInspector: (value) => {
  //     set({ asignarInspector: value });
  //   },
  //   setInspectorAsignado: (inspector) => {
  //     set({ inspectorAsignado: inspector });
  //   },
  //   setSolicitudesAsignar: (id) => {
  //     set((state) => {
  //       const yaExiste = state.solicitudesAsignar.includes(id);
  //       const nuevasSolicitudes = yaExiste
  //         ? state.solicitudesAsignar.filter((solicitudId) => solicitudId !== id)
  //         : [...state.solicitudesAsignar, id];

  //       return { solicitudesAsignar: nuevasSolicitudes };
  //     });
  //   },
}));
